/**
 * Shared error state component for popup pages
 */
import React from 'react';
import { Button } from '@ais-ui/ui-core';
import { closePopup } from '@ais-ui/popups';

interface PopupErrorStateProps {
  title?: string;
  message: string;
  onClose?: () => void;
  closeButtonText?: string;
}

export const PopupErrorState: React.FC<PopupErrorStateProps> = ({
  title = 'Error',
  message,
  onClose,
  closeButtonText = 'Close Window',
}) => {
  const handleClose = onClose || closePopup;

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-background">
      <div className="text-destructive text-lg font-medium mb-4">{title}</div>
      <p className="text-muted-foreground mb-4 text-center max-w-md">
        {message}
      </p>
      <Button onClick={handleClose}>{closeButtonText}</Button>
    </div>
  );
};
